import { joinBy } from '@ama-selections/ui'
import Form from 'components/form'
import { RestUser } from 'data/types/user'
import CustomerPassportImageUpload from './CustomerPassportImageUpload'

const ViewDetails = ({
  user,
}: {
  user: RestUser,
}) => {
  return (
    <div className="grid grid-cols-3 font-normal gap-15 xl:ml-20">
      <div className="text-grey-900">Name:</div>
      <div className="col-span-2 text-grey-700">{user.first_name}</div>
      <div className="text-grey-900">Last Name:</div>
      <div className="col-span-2 text-grey-700">{user.last_name}</div>
      <div className="text-grey-900">Email:</div>
      <div className="col-span-2 text-grey-700">{user.email}</div>
      <div className="text-grey-900">Phone:</div>
      <div className="col-span-2 text-grey-700">+{user.phone_country_code} {user.phone}</div>
      <div className="text-grey-900">Address:</div>
      <div className="col-span-2 text-grey-700 mb-30">
        <div>
          {user.address?.line_1}
        </div>
        <div>
          {user.address?.line_2}
        </div>
        <div>
          {joinBy([user.address?.city, user.address?.postcode], ', ')}
        </div>
        <div>
          {joinBy([user.address?.state, user.address?.country], ', ')}
        </div>
      </div>

      <div className="relative grid grid-cols-3 col-span-3">
        <div className="text-grey-900">Passport:</div>
        <Form.Field className="flex flex-col col-span-2 gap-5 text-grey-700">
          <CustomerPassportImageUpload
            value={user?.passport_image}
            identityVerifiedAt={user?.identity_verified_at}
          />
        </Form.Field>
      </div>
    </div>
  )
}

export default ViewDetails
